///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.create = abcsetup.rfq.create || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.create = {
    init: function() {
        abcsetup.setTitle('Submit an RFQ Bid');

        // init the RFQ common lib
        abcsetup.rfq.common.init();
    },

    /**
     * _jquery.fieldValidate
     *      fieldError callback
     */
    fieldError: function() {
        abcsetup.unblockUI();
        abcsetup.rfq.common.fieldError();
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function() {
        if (abcsetup.uploader.uploadResult.id) {
            var msg = '';

            $('#item-accordion, .item_attachments, .btn-attach').hide();
            $('.control-buttons').parent().hide();

            if (abcsetup.uploader.uploadResult.imported) {
                msg += 'Items successfully imported: ' + abcsetup.uploader.uploadResult.imported + '<br>';
            }

            if (abcsetup.uploader.uploadResult.failed) {
                msg += 'Items imports failed: ' + abcsetup.uploader.uploadResult.failed + '<br>';
            }

            abcsetup.alerts.show('Item Imports', msg, function() {
                abcsetup.blockUI(true);
                window.location.href ='/rfq/' + abcsetup.uploader.uploadResult.id + '/edit';
            });

        } else {
            abcsetup.alerts.show('No items imported', 'Item import failed - please double check the template you specified');
        }
    },
}
